import { NodeType } from "@tiptap/pm/model";
import {
  InputRule,
  InputRuleFinder,
  callOrReturn,
  ExtendedRegExpMatchArray,
} from "@tiptap/core";

export function mergeTagInputRule(config: {
  /**
   * The regex to match.
   */
  find: InputRuleFinder;

  /**
   * The node type to add.
   */
  type: NodeType;

  /**
   * A function that returns the attributes for the node
   * can also be an object of attributes
   */
  getAttributes?:
    | Record<string, any>
    | ((match: ExtendedRegExpMatchArray) => Record<string, any>)
    | false
    | null;
}) {
  return new InputRule({
    find: config.find,
    handler: ({ state, range, match }) => {
      const attributes =
        callOrReturn(config.getAttributes, undefined, match) || {};
      const { tr } = state;
      const start = range.from;
      const end = range.to + 1;

      // storedMarks are set when user toggles formatting without typing (e.g. clicks Bold then types a merge tag);
      // fall back to marks at the insertion position so pasted / auto-completed tags inherit surrounding formatting.
      const marks = state.storedMarks ?? state.doc.resolve(start).marks();

      const newNode = config.type.create(attributes, null, marks);

      // insert last typed character
      const lastChar = match[0][match[0].length - 1];

      tr.insertText(lastChar, start + match[0].length - 1);

      // insert node from input rule
      tr.replaceWith(start, end, newNode);

      tr.scrollIntoView();
    },
  });
}
